module.exports = __webpack_public_path__ + "img/bg_10.8e26c02e.png";